module.exports = __webpack_public_path__ + "static/media/chat.cbdac5f6.svg";